module.exports = __webpack_public_path__ + "img/holzdeck03.11f2bb67.jpg";